 // 项目中会把对应的接口请求封装成api进行调用
import service from "../js/service";
import service2 from "../js/service2";
// import qs from 'qs';
// bdsm问题
export function problem(data) {
  return service({ method: "post", url: "/nico.php", data });
}
// bdsm结果
export function getAnswer(data) {
  return service({ method: "post", url: "/nico.php", data });
}
// mbti问题
export function problemMbti(data) {
  return service2({ method: "get", url: "/mbti.php", data });
}
// mbti结果
export function getAnswerMbti(data) {
  return service2({ method: "post", url: "/mbti.php", data });
}
 
// // 登录接口
// export function login(data) {
//   data = qs.stringify(data);
//   return service({ method: "post", url: "/login", data });
// }
// // 学生列表查询接口
// export function students(params) {
//   return service({ method: "get", url: "/students", params });
// }
